import { Link } from 'react-router-dom';
import { Post } from '@/hooks/usePosts';

interface FeaturedPostProps {
  post: Post;
}

export default function FeaturedPost({ post }: FeaturedPostProps) {
  return (
    <section className="w-full bg-background-50 py-8 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-center">
          {/* Image */}
          <div className="w-full md:w-[45%] h-[180px] sm:h-[260px] md:h-[360px] rounded-xl overflow-hidden flex-shrink-0 group/img">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover object-top
                scale-100 group-hover/img:scale-105
                transition-transform duration-500 ease-out"
            />
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <span className="text-primary-500 text-[10px] md:text-xs font-bold tracking-widest uppercase mb-2 md:mb-3 block">
              Artigo em Destaque
            </span>
            <h2 className="font-heading font-bold text-foreground-950 text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-tight mb-3 md:mb-4">
              {post.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 md:mb-5 line-clamp-2 md:line-clamp-none">
              {post.subtitle}
            </p>
            <p className="text-foreground-400 text-xs md:text-sm mb-4 md:mb-5 flex items-center justify-center md:justify-start gap-1">
              <i className="ri-time-line text-xs"></i> {post.readTime}
            </p>
            <Link
              to={`/post/${post.slug}`}
              className="group/link inline-flex items-center gap-2 text-primary-500 hover:text-primary-700 text-sm font-bold transition-colors duration-200 cursor-pointer"
            >
              Ler artigo
              <i className="ri-arrow-right-line
                group-hover/link:translate-x-1
                transition-transform duration-200"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}